module.exports = __webpack_public_path__ + "img/watatsuki no toyohime_sc1.a32c2132.png";